import { THeaderType } from 'components/Header/Header'
import LinkWithLocale from 'components/LinkWithLocale'
import React, { FC, useState } from 'react'
import styled from 'styled-components'
import BadgeWarning from 'ui/Badge'
import BadgeDropdown, { BadgeType } from '../BadgeDropdown/BadgeDropdown'
import { CENTERED_DROPDOWNS_TYPES } from './constants'
// import DropdownNavPreviewBlock from '../DropdownApp/PreviewBlock'

enum DropdownType {
  'app',
  'buy crypto',
  'futures',
  'spot',
  'explore trading',
  'price alerts',
  'staking',
  'markets',
  'refferal',
}

interface DropdownContainerProps extends IOwnProps {
  dropdownType: DropdownType | string
  dropdown: boolean
  link?: string
}

const DropdownContainer: FC<DropdownContainerProps> = ({
  name,
  icon,
  linkIcon,
  warning,
  type,
  dropdown,
  dropdownType,
  badgeType,
  link,
  // dropdowns,
  children,
}) => {
  const [isActive, setIsActive] = useState(false)

  // const {
  //   // buttonLink,
  //   buttonText,
  //   heading1,
  //   // heading2,
  //   image1: {
  //     data: {
  //       attributes: { url },
  //     },
  //   },
  //   // list,
  //   // text1,
  // } = dropdowns.data[0].attributes.dropdown1[0]

  // const src = `${process.env.GATSBY_API_URL}${url}`

  return (
    <DropdownWrapper
      onClick={() => setIsActive(true)}
      onMouseEnter={() => setIsActive(true)}
      onMouseLeave={() => setIsActive(false)}>
      <NameContainer $isActive={isActive} $dropdown={dropdown} $type={type}>
        {link ? (
          <StyledLink $isActive={isActive} $type={type} to={link} withLocale={false}>
            {name}
            <BadgeDropdown type={badgeType} text={badgeType} />
          </StyledLink>
        ) : icon ? (
          <img src={icon} alt={name} />
        ) : (
          <Name>{name}</Name>
        )}
        {linkIcon && <IconContainer>{linkIcon}</IconContainer>}
        {warning && <BadgeWarningWrapper>{warning}</BadgeWarningWrapper>}
      </NameContainer>
      <Dropdown
        $dropdownType={dropdownType}
        $isActive={isActive}
        $centered={CENTERED_DROPDOWNS_TYPES.includes(String(dropdownType))}>
        {children}
      </Dropdown>
    </DropdownWrapper>
  )
}

export default DropdownContainer

const DropdownWrapper = styled.div`
  position: relative;
  -webkit-tap-highlight-color: transparent;
`

const NameContainer = styled.div<{
  $type: THeaderType
  $dropdownType?: DropdownContainerProps
  $dropdown: boolean
  $isActive?: boolean
}>`
  display: flex;
  align-items: center;
  color: ${({ $type, theme: { colors } }) =>
    $type === 'primary' ? colors.newDarkColor.softNavy : colors.newLightColor.white};
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;
  white-space: nowrap;
  ${({ $dropdown }) =>
    $dropdown &&
    `
    &::after {
      display: inline-block;
      vertical-align: 3.96px;
      content: '';
      width: 9px;
      height: 6px;
      margin-top: 4px;
      border-style: solid;
      border-width: 6px 5px 0 5px;
      border-color: #6b7b9f transparent transparent transparent;

    }
    `}
  ${({ $isActive, $type, theme: { colors } }) =>
    $isActive &&
    `
    color: ${$type === 'primary' ? colors.newLightColor.vividBlue : colors.newDarkColor.cyanBlue};
    ::after {
      transition: all 0.1s ease-out;
      border-color: ${
        $type === 'primary' ? '#97b8f7' : colors.newDarkColor.cyanBlue
      }  transparent transparent transparent;
      transform: rotate(180deg);
    }
  `}
`

const Dropdown = styled.div<{ $isActive?: boolean; $dropdownType?: DropdownType | string; $centered?: boolean }>`
  display: ${({ $isActive }) => ($isActive ? 'grid' : 'none')};
  ${({ $centered }) =>
    $centered &&
    `left: 50%;
  transform: translateX(-50%);

  [dir='rtl'] & {
    left: auto;
    right: -200%;
    transform: unset;
  }
  `}
  ${({ $dropdownType }) =>
    $dropdownType === 'price alerts' ? `grid-template-columns: 1fr;` : `grid-template-columns: 1fr 1fr;`}
  
  position: absolute;
  top: 100%;
  ${({ $dropdownType }) =>
    $dropdownType === 'markets' ? `left: auto; right: auto; transform: translateX(-66%);` : `left: 0; right: 0;`};
  z-index: 10;
  min-width: 10rem;
  margin: 2rem 0 0;
  font-size: ${({ theme: { fontSize } }) => fontSize.base};
  color: ${({ theme: { colors } }) => colors.default};
  text-align: left;
  list-style: none;
  background-clip: padding-box;
  width: fit-content;
  border-radius: 0.5rem;
  box-shadow: 0px 15px 50px rgb(15 42 102 / 70%);
  transition: opacity 0.4s, visibility 0.4s;

  &::before {
    content: '';
    height: 35px;
    top: -35px;
    left: 0;
    right: 0;
    z-index: -1;
    position: absolute;
  }

  @media ${({ theme }) => theme.device.lgMax} {
    left: 5%;

    &::after {
      left: 55%;
    }
  }
`
const Name = styled.span`
  margin-inline-end: 5px;

  @media ${props => props.theme.device.xxm} and (max-width: 1399px) {
    font-size: 13px;
    margin-inline-end: 3px;
  }
`
const StyledLink = styled(LinkWithLocale)<{
  $type: THeaderType
  $isActive?: boolean
}>`
  margin-inline-end: 5px;
  color: ${({ $type, theme: { colors } }) =>
    $type === 'primary' ? colors.newDarkColor.softNavy : colors.newLightColor.white};
  ${({ $isActive, $type, theme: { colors } }) =>
    $isActive &&
    `
    color: ${$type === 'primary' ? colors.newLightColor.vividBlue : colors.newDarkColor.cyanBlue};
    ::after {
      transition: all 0.1s ease-out;
      border-color: ${
        $type === 'primary' ? '#97b8f7' : colors.newDarkColor.cyanBlue
      }  transparent transparent transparent;
      transform: rotate(180deg);
    }
  `}

  & > span {
    margin-inline-start: 4px;
  }
`

const IconContainer = styled.div`
  width: 24px;
  height: 24px;

  @media ${props => props.theme.device.xxm} and (max-width: 1399px) {
    width: 22px;
    height: 22px;
  }
`

const BadgeWarningWrapper = styled(BadgeWarning)`
  margin-inline-start: 0.5em;
`

interface IOwnProps {
  name?: string
  icon?: string
  linkIcon?: JSX.Element
  // options: Array<{ name: string; url: string }>
  warning?: string | null
  type: THeaderType
  badgeType?: BadgeType
  // dropdowns: any
}
